import React from 'react';
import { Routes, Route } from "react-router-dom";

import { VerificationContextProvider } from '../../context/verificationContext';

import Verification from './Verification';
import AddEditVerificationScheduleStep1 from './addEditVerificationScheduleStep1';
import AddEditVerificationScheduleStep2 from './addEditVerificationScheduleStep2';
import AddEditVerificationScheduleStep3 from './addEditVerificationScheduleStep3';
import ActivityRegister from './activityRegister';

function VerificationIndex(props) {
    return (
        <VerificationContextProvider>
            <Routes>
                <Route exact path={`/`} Component={Verification} />
                <Route exact path={`/:verId/activity-register`} Component={ActivityRegister} />
                <Route exact path={`/:formMode/step1/:vsId`} Component={AddEditVerificationScheduleStep1} />
                <Route exact path={`/:formMode/step1`} Component={AddEditVerificationScheduleStep1} />
                <Route exact path={`/:formMode/step2/:vsId`} Component={AddEditVerificationScheduleStep2} />
                <Route exact path={`/:formMode/step2`} Component={AddEditVerificationScheduleStep2} />
                <Route exact path={`/:formMode/step3/:vsId`} Component={AddEditVerificationScheduleStep3} />
                <Route exact path={`/:formMode/step3`} Component={AddEditVerificationScheduleStep3} />
            </Routes>
        </VerificationContextProvider>
    );
}

export default VerificationIndex;
